import * as React from 'react';

import { formatDate } from '@acceligentllc/shared/utils/time';

import { NotificationStatusEnum } from '@acceligentllc/shared/enums/notificationStatus';
import { SubscriptionStatus } from '@acceligentllc/shared/enums/subscriptionStatus';
import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import { wrapElementWithTooltip } from 'af-utils/tooltip.util';

import { NOTIFY_MODAL_COL_SPAN } from 'af-constants/values';

interface OwnProps {
	phoneNumber: string;
	lastSmsSentStatus: NotificationStatusEnum;
	subscriptionStatus: SubscriptionStatus;
	lastSmsSentAt: Date;
	phoneInvalidatedAt: Date;
	errorMessage: string;
}

type Props = OwnProps;

export default class SmsStatusInfo extends React.PureComponent<Props> {

	getEmployeeSmsColorApplication = () => {
		const { lastSmsSentStatus } = this.props;

		switch (lastSmsSentStatus) {
			case NotificationStatusEnum.OPENED:
				return 'text-green';
			case NotificationStatusEnum.ERROR:
				return 'text-red';
			default:
				return '';
		}
	};

	getEmployeeSmsOverlayMessage = () => {
		const { lastSmsSentStatus, errorMessage } = this.props;

		switch (lastSmsSentStatus) {
			case NotificationStatusEnum.QUEUED:
				return 'Notification has been sent to this participant, but he hasn\'t received it yet.';
			case NotificationStatusEnum.ERROR:
				return errorMessage;
			case NotificationStatusEnum.OPENED:
				return 'The participant has opened the link sent in the last sms.';
			default:
				return null;
		}
	};

	employeeSmsStatusInfo = (): React.JSX.Element => {
		const {
			lastSmsSentAt,
			lastSmsSentStatus,
			phoneInvalidatedAt,
		} = this.props;

		return (
			<>
				{lastSmsSentStatus !== NotificationStatusEnum.SCHEDULED && lastSmsSentAt ? formatDate(lastSmsSentAt, TimeFormat.FULL_DATE) : '-'}
				{lastSmsSentStatus === NotificationStatusEnum.ERROR && phoneInvalidatedAt && <span className="icon-info text-red" />}
			</>
		);
	};

	render() {
		const { subscriptionStatus } = this.props;
		const hasResubscribed = subscriptionStatus === SubscriptionStatus.RESUBSCRIBED;

		return (
			<td
				className={this.getEmployeeSmsColorApplication()}
				colSpan={NOTIFY_MODAL_COL_SPAN.SEND_TIME}
			>
				{
					subscriptionStatus === SubscriptionStatus.SUBSCRIBED ?
						wrapElementWithTooltip(
							this.employeeSmsStatusInfo(),
							this.getEmployeeSmsOverlayMessage()
						) :
						<strong className={hasResubscribed ? 'text-green' : 'text-red'}>
							{hasResubscribed ? 'SUBSCRIBED' : 'UNSUBSCRIBED'}
						</strong>
				}
			</td>
		);
	}
}
